export const testIds = {
  closeDialogButton: 'dialog-close-button',
  favoriteLists: {
    dialog: {
      dialog: 'favorite-lists_dialog_modal',
      input: 'favorite-lists_dialog-input_field',
      cancel: 'favorite-lists_dialog-cancel_button',
      delete: 'favorite-lists_dialog-delete_button',
      save: 'favorite-lists_dialog-save_button',
      item: 'favorite-lists_dialog-item_button',
      selected: {
        container: 'favorite-lists_dialog-selected_container',
        empty: 'favorite-lists_dialog-selected-empty_content',
        item: 'favorite-lists_dialog-selected-item_content',
        remove: 'favorite-lists_dialog-selected-remove_button'
      }
    },
    dropdown: {
      all: 'favorite-lists_dropdown-all_button',
      item: 'favorite-lists_dropdown-item_button',
      edit: 'favorite-lists_dropdown-edit_button',
      create: 'favorite-lists_dropdown-create_button'
    }
  },
  liveTv: {
    content: {
      screen: {
        player: {
          cancelRecordingConfirm: {
            cancelText: 'live-tv-content-screen-player-cancel-recording-confirm-cancel-text',
            confirmButton: 'live-tv-content-screen-player-cancel-recording-confirm-confirm-button',
            header: 'live-tv-content-screen-player-cancel-recording-confirm-header',
            rejectButton: 'llive-tv-content-screen-player-cancel-recording-confirm-reject-button',
            root: 'live-tv-content-screen-player-cancel-recording-confirm-root',
            titleText: 'live-tv-content-screen-player-cancel-recording-confirm-title-text'
          }
        }
      }
    },
    contentInfo: {
      current: {
        container: 'live-tv_content-info-current_container'
      },
      next: {
        container: 'live-tv_content-info-next_container',
        cancelRecording: 'live-tv_content-info-next-cancel-recording_button',
        startRecording: 'live-tv_content-info-next-start-recording_button',
        recordingLabel: 'live-tv_content-info-next-recording-label_content'
      },
      headline: 'live-tv_content-info-headline_content',
      title: 'live-tv_content-info-title_content',
      image: 'live-tv_content-info-image_content',
      info: 'live-tv_content-info-info_content',
      airtimes: 'live-tv_content-info-airtimes_content',
      recordingCurrentProgram: 'live-tv_content-info-recording-status_content-current-program',
      recordingNextProgram: 'live-tv_content-info-recording-status_content-next-program'
    },
    sidebar: {
      sort: 'live-tv_sidebar-sort_button',
      list: 'live-tv_sidebar-list_container',
      item: {
        container: 'live-tv_sidebar-item-container_button',
        image: 'live-tv_sidebar-item-image_content',
        title: 'live-tv_sidebar-item-title_content',
        time: 'live-tv_sidebar-item-time_content',
        progressBar: 'live-tv_sidebar-item-progress-bar_content',
        next: {
          time: 'live-tv_sidebar-item-next-time_content',
          title: 'live-tv_sidebar-item-next-title_content'
        }
      }
    }
  },
  cookieBanner: {
    cookiePolicy: 'cookie-banner_cookie-policy_link',
    showCookies: 'cookie-show-cookies_link',
    accept: 'cookie-banner_accept_button',
    reject: 'cookie-banner_reject_button'
  },
  gdpr: {
    dialog: 'gdpr-modal_modal',
    header: 'gdpr-modal-header_content',
    textMain: 'gdpr-modal-text-main_content',
    textLast: 'gdpr-modal-text-last_content',
    link: 'gdpr-modal-link_link',
    button: 'gdpr-modal-button_button'
  },
  general: {
    clock: 'generic_clock_content'
  },
  header: {
    logo: 'header_logo',
    navigation: {
      frontPage: 'header-navigation_front-page_link',
      tvGuide: 'header-navigation_tv-guide_link',
      settings: 'header-navigation_settings_link',
      explore: 'header-navigation_explore_link',
      developer: 'header-navigation_developer_link',
      search: 'header-navigation_search_link'
    }
  },
  login: {
    header: 'login_header_content',
    email: 'login_email_field',
    password: 'login_password_field',
    displayPassword: 'login_display-password_button',
    errorMessage: 'login_error-message_text',
    submit: 'login_submit_button',
    forgotPassword: 'login_forgot-password_button',
    gdprText: 'login_gdpr-text_content',
    readGdpr: 'login_read-gdpr_button',
    logo: 'login_logo-image_content',
    coverImage: 'login_cover-image_content',
    forgotPasswordDialog: {
      dialog: 'login_forgot-password-modal_modal',
      header: 'login_forgot-password-modal-header_content',
      text: 'login_forgot-password-modal-text_content',
      email: 'login_forgot-password-modal-email_field',
      errorMessage: 'login_forgot-password-modal-error-message',
      sendMail: 'login_forgot-password-modal-send-mail_button',
      backButton: 'login_forgot-password-modal-back_button'
    }
  },
  frontPage: {
    hero: 'frontpage_hero',
    title: 'frontpage_title',
    info: 'frontpage_info',
    universeName: 'frontpage_universe-name'
  },
  tvGuide: {
    moreInfo: {
      title: 'tv-guide_more-info-title_content',
      info: 'tv-guide_more-info-info_content',
      period: 'tv-guide_more-info-period_content',
      progressBar: 'tv-guide_more-info-progress-bar_content',
      image: 'tv-guide_more-info-image_content',
      buttons: {
        live: 'tv-guide_more-info-live_button',
        date: 'tv-guide_more-info-date_button',
        favorites: 'tv-guide_more-info-favorites_button'
      }
    },
    timeline: {
      item: 'tv-guide_timeline-item_content',
      liveMarker: 'tv-guide_timeline-current-live-marker_content'
    },
    grid: {
      channelItem: 'tv-guide_grid-channel-item_content',
      programItem: 'tv-guide_grid-program-item_content'
    },
    filter: {
      calendar: {
        dialog: 'tv-guide_filter-calendar-dialog_modal',
        title: 'tv-guide_filter-calendar-title_content',
        list: 'tv-guide_filter-calendar-list_content',
        item: 'tv-guide_filter-calendar-item_content'
      },
      favorites: {
        dialog: 'tv-guide_filter-favorites-dialog_modal',
        title: 'tv-guide_filter-favorites-title_content',
        list: 'tv-guide_filter-favorites-list_content',
        item: 'tv-guide_filter-favorites-item_content',
        edit: 'tv-guide_filter-favorites-edit_button'
      }
    }
  },
  settings: {
    header: 'settings_header_content',
    tabs: {
      favoritesList: 'settings_tabs-favorites-list_tab',
      npvr: 'settings_tabs-npvr_tab',
      tech: 'settings_tabs-tech_tab',
      openSource: 'settings_tabs-open-source_tab',
      gdpr: 'settings_tabs-gdpr_tab'
    },
    techTable: {
      table: 'settings_table-tech_table',
      userReferenceId: 'settings_table-tech-user-reference-id_row',
      email: 'settings_table-tech-email_row',
      appVersion: 'settings_table-tech-version_row',
      hardwareModel: 'settings_table-tech-hardware-model_row',
      osVersion: 'settings_table-tech-os-version_row',
      detailedAppVersion: 'settings_table-tech-detailed-app-version_row',
      connectionType: 'settings_table-tech-connection-type_row'
    },
    openSourceTable: {
      table: 'settings_table-open-source_table',
      row: 'settings_table-open-source-'
    },
    logout: 'settings_logout_button',
    logoutDialog: {
      dialog: 'settings_logout-modal_modal',
      header: 'settings_logout-modal-header_content',
      text: 'settings_logout-modal-text_content',
      submit: 'settings_logout-modal-submit_button',
      cancel: 'settings_logout-modal-cancel_button'
    }
  },
  contentItem: {
    root: 'content-item_root_content',
    title: 'content-item_title_content',
    image: 'content-item_image_content',
    logo: 'content-item_logo_content',
    progress: 'content-item_progress-bar_content',
    startTime: 'content-item_start-time_content',
    timespan: 'content-item_live_timespan_content',
    live: {
      duration: 'content-item_live_duration_content'
    }
  },
  contentSlider: {
    root: 'content-slider_root_content',
    title: 'content-slider_header_content',
    headerTitle: 'content-slider_header-title_content',
    actions: {
      showAll: 'content-slider_actions-show-all_button',
      prev: 'content-slider_actions-prev_button',
      next: 'content-slider_actions-next_button'
    }
  },
  collections: {
    root: 'collections_root',
    title: 'collections_title',
    closeButton: 'collections_close_button'
  },
  favorites: {
    home: {
      root: 'favorites_home-root',
      title: 'favorites_home-title',
      listItem: 'favorites_home-list-item',
      dialogItem: 'favorites_home-dialog-item',
      listRow: 'favorites_home-list-row',
      itemActions: {
        edit: 'favorites_home-item_edit-button',
        delete: 'favorites_home-item_delete-button',
        backButton: 'favorites_home-back-button'
      },
      create: 'favorites_home-create',
      text: 'favorites_home-text',
      channels: 'favorites_home-channels',
      channelsDescription1: 'favorites_home_channels-description1',
      channelsDescription2: 'favorites_home_channels-description2'
    },
    edit: {
      root: 'favorites_edit-root',
      title: 'favorites_edit-title',
      channels: 'favorites_edit-channels',
      channelsItem: 'favorites_edit-channels-item_row',
      selectedChannels: 'favorites_edit-selected-channels',
      selectedChannelsItem: 'favorites_edit-selected-channels-item_row',
      listTitle: 'favorites_edit-list-title',
      save: 'favorites_edit-save_button',
      rename: 'favorites_edit-rename_button',
      back: 'favorites_edit-back_button'
    },
    save: {
      root: 'favorites_save-root',
      title: 'favorites_save-title',
      listTitle: 'favorites_save-list-title',
      save: 'favorites_save-save_button',
      cancel: 'favorites_save-cancel_button'
    },
    rename: {
      root: 'favorites_rename-root',
      title: 'favorites_rename-title',
      input: 'favorites_rename-input_field',
      error: 'favorites_rename-error',
      save: 'favorites_rename-save_button',
      cancel: 'favorites_rename-cancel_button'
    },
    delete: {
      root: 'favorites_delete-root',
      title: 'favorites_delete-title',
      listTitle: 'favorites_delete-list-title',
      submit: 'favorites_delete-submit_button',
      cancel: 'favorites_save-cancel_button'
    }
  },
  player: {
    root: 'player_root',
    controls: {
      root: 'player_controls-root',
      title: 'player_controls-title',
      meta: 'player_controls-meta_content',
      progress: 'player_controls-progress_content',
      info: 'player_controls-info_button',
      settings: 'player_controls-subtitles_button'
    },
    playerControls: {
      play: 'player-controls_play_button',
      pause: 'player-controls_pause_button',
      back: 'player-controls_back_button',
      skipBackward: 'player-controls_skip-backward_button',
      skipForward: 'player-controls_skip-forward_button',
      startOver: 'player-controls_start-over_button',
      live: 'player-controls_live_button',
      scrubber: 'player-controls_scrubber_container',
      liveMarker: 'player-controls_live-marker_content',
      mute: 'player-controls_mute_button',
      unmute: 'player-controls_unmute_button',
      volume: 'player-controls_volume_container',
      playtime: 'player-controls_playtime_content',
      settings: 'player-controls_settings_button',
      enterFullscreen: 'player-controls_enter-fullscreen_button',
      exitFullscreen: 'player-controls_exit-fullscreen_button',
      startRecording: 'player-controls_start-recording_button',
      cancelRecording: 'player-controls_cancel-recording_button',
      leftTime: 'player-controls_left-time_content',
      rightTime: 'player-controls_right-time_content',
      fullscreen: 'player-controls_fullscreen_button',
      channelList: 'player-controls_channel-list_button',
      volumeSlider: 'player-controls_volume-slider_container',
      toggleSound: 'player-controls_toggle-sound_button'
    },
    channels: {
      root: 'player_channels-root',
      channel: {
        root: 'player_channels_channel-root',
        logo: 'player_channels_channel-logo',
        timespan: 'player_channels_channel-timespan',
        title: 'player_channels_channel-title',
        progress: 'player_channels_channel-progress',
        nextTimespan: 'player_channels_channel-next-timespan',
        nextTitle: 'player_channels_channel-next-title'
      }
    },
    subtitlesDialog: {
      label: 'player_subtitles-dialog-text',
      button: 'player_subtitles-dialog-item',
      buttonGroup: 'player_subtitles-dialog-button-group'
    },
    audioDialog: {
      label: 'player_audio-dialog-text',
      button: 'player_audio-dialog-item',
      buttonGroup: 'player_audio-dialog-button-group'
    },
    settingsOverlay: {
      dialog: 'player_settings-dialog-dialog_modal',
      title: 'player_settings-dialog-title',
      text: 'player_settings-dialog-text'
    },
    tv2Dialog: {
      dialog: 'player_tv2-dialog_dialog_modal',
      title: 'player_tv2-dialog_title',
      administerButton: 'player_tv2-dialog_administer_button',
      goBackButton: 'player_tv2-dialog_go-back_button',
      removeAllButton: 'player_tv2-dialog_remove-all_button',
      continuePlayingButton: 'player_tv2-dialog_continue-playing_button',
      removeDeviceButton: 'player_tv2-dialog_remove-device_button'
    }
  },
  programsheet: {
    dialog: 'program-sheet-dialog_modal',
    cover: 'program-sheet-cover',
    header: 'program-sheet-header',
    content: {
      actors: 'program-sheet-content-actors',
      description: 'program-sheet-content-description',
      directors: 'program-sheet-content-directors',
      info: 'program-sheet-content-info',
      episode: 'program-sheet-content-episode',
      actions: {
        live: 'program-sheet-content-actions-live',
        catchup: 'program-sheet-content-actions-catchup'
      },
      extendedDescription: {
        backButton: 'program-sheet-content-extended-description-back-button',
        title: 'program-sheet-content-extended-description-title'
      }
    },
    buttons: {
      play: 'program-sheet-buttons-play',
      replay: 'program-sheet-buttons-replay',
      record: 'program-sheet-buttons-record',
      favorite: 'program-sheet-buttons-favorite',
      close: 'program-sheet-buttons-close',
      seasonPicker: 'program-sheet-buttons-season-picker',
      deleteRecording: 'program-sheet-buttons-delete-recording'
    },
    info: {
      meta: 'program-sheet-meta',
      airtime: 'program-sheet-info-airtime',
      box: 'program-sheet-info-box',
      provider: 'program-sheet-info-provider',
      progressBar: 'program-sheet-info-progressBar',
      progressBarLive: 'program-sheet-info-progressBar-live'
    },
    seasonPicker: {
      dialog: 'program-sheet-season-picker_dialog_modal',
      list: 'program-sheet-season-picker-list',
      title: 'program-sheet-season-picker-title',
      item: 'program-sheet-season-picker-item'
    },
    providers: {
      picker: 'sheet-providers-picker_dialog_modal',
      title: 'sheet-providers-picker-title',
      item: 'sheet-providers-picker-item'
    }
  },
  explorePicker: {
    title: 'explore-picker_title',
    buttons: {
      exploreButton: 'explore-picker_buttons-tile-button'
    }
  },
  providerUniverse: {
    menuBar: 'provider-universe_menu-bar',
    menuBarItem: 'provider-universe_menu-bar-item'
  },
  npvr: {
    tab: {
      storage: 'npvr_storage',
      recordings: 'npvr_recordings',
      expiring: 'npvr_expiring',
      planned: 'npvr_planned',
      errors: 'npvr_errors'
    }
  },
  search: {
    input: 'search_input_field'
  }
};

export const navigationTestIdMap: { [key: string]: string } = {
  hjem: testIds.header.navigation.frontPage,
  tvguide: testIds.header.navigation.tvGuide,
  indstillinger: testIds.header.navigation.settings,
  udforsk: testIds.header.navigation.explore,
  udvikler: testIds.header.navigation.developer,
  søg: testIds.header.navigation.search
};

export const loginEmailInputFieldFocusKey = 'login_email_field';

export default testIds;
